import { render, staticRenderFns } from "./MenuMore.vue?vue&type=template&id=435d58f8&"
import script from "./MenuMore.vue?vue&type=script&lang=js&"
export * from "./MenuMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435d58f8')) {
      api.createRecord('435d58f8', component.options)
    } else {
      api.reload('435d58f8', component.options)
    }
    module.hot.accept("./MenuMore.vue?vue&type=template&id=435d58f8&", function () {
      api.rerender('435d58f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuMore.vue"
export default component.exports